import axios from "axios/index";
import {apiCall} from "../../common/apiActionHandler";
import {mapForSelect} from "../../common/commonHandlers";
import {dataUpload} from "../../common/upload";

export const getTimeTracks = (filter, callback) => async (dispatch, getState) => {
    const config = {
        url: `/api/time_tracks`,
        params: filter
    };

    apiCall("Getting customers", config, async config => {
        const response = await axios.request(config);
        callback(response.data);
    }, dispatch, getState, false);
};

export const load = callback => (dispatch, getState) => {
    const config = [
        {url: `/api/search/all_employees`},
        {url: `/api/time_track_types`},
        {url: `/api/new_proposals/search`, params: {q: ''}},
        {url: `/api/work_orders/new_search`, params: {q: ''}}
    ];

    apiCall("Loading data", config, async config => {
        let actions = config.map(c => axios.request(c));
        const all = await axios.all(actions);
        callback({
            employees: all[0].data,
            time_track_types: mapForSelect(all[1].data),
            proposals: mapForSelect(all[2].data),
            work_orders: mapForSelect(all[3].data)
        });
    }, dispatch, getState, false);
};

export const searchForCustomer = (searchText, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/customers/name_zip_city_search`,
        params: {q: searchText}
    };

    apiCall("Searching for customers", config, async config => {
        const response = await axios.request(config);
        callback(mapForSelect(response.data));
    }, dispatch, getState, false);
};

export const searchForProposal = (searchText, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/new_proposals/search`,
        params: {q: searchText}
    };

    apiCall("Searching for proposals", config, async config => {
        const response = await axios.request(config);
        callback(mapForSelect(response.data));
    }, dispatch, getState, false);
};

export const searchForWorkOrder = (searchText, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/work_orders/new_search`,
        params: {q: searchText}
    };

    apiCall("Searching for work orders", config, async config => {
        const response = await axios.request(config);
        callback(mapForSelect(response.data));
    }, dispatch, getState, false);
};

export const saveTimeTracks = (time_track) => (dispatch, getState) => {
    const config = {
        url: `/api/time_tracks/${time_track.id}`,
        data: {time_track},
        method: 'PUT'
    };

    apiCall("Saving time tracks", config, async config => {
        await axios.request(config);
    }, dispatch, getState);
};
export const stopTimeTracks = (time_track_ids, stop_time, callback) => (dispatch, getState) => {
    const config = {
        url: `/api/crew_work_orders/stop_time_tracks`,
        method: 'POST',
        data: {
            time_track_ids: time_track_ids,
            stop_time: stop_time
        }
    };

    apiCall("Stop time", config, async config => {
        const result = await axios.request(config);
        callback && callback(result.data);
    }, dispatch, getState, false);
};

export const saveDownloadedFile = (blob, params, source) => (dispatch, getState) => {
    dataUpload(`/api/download_history`, blob, null, null, {
        params: JSON.stringify(params ? params : {}),
        source: source
    }, false)(dispatch, getState)
}